"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnboardingMetadata = void 0;
const Channel_1 = require("./onboardingmetadata/Channel");
const DistributionPartner_1 = require("./onboardingmetadata/DistributionPartner");
const Platform_1 = require("./onboardingmetadata/Platform");
exports.OnboardingMetadata = {
    channel: Channel_1.Channel,
    distribution_partner: DistributionPartner_1.DistributionPartner,
    platform: Platform_1.Platform,
};
